import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { Mongo } from 'meteor/mongo';
import { Roles } from 'roles';

import { BaseSchema } from '../baseSchema';

import GoogleMapsField from '../../components/fields/googleMapsField';

export const Places = new Mongo.Collection('places');
export default Places;

Places.attachRoles('places');

Places.label = "Lieu d'envol";

export const PlaceSchema = new SimpleSchema([{
    name: {
        type: String,
        label: "Nom du lieu",
        uniforms: {
			component: GoogleMapsField
		}
    },
    precision: {
    	type: String,
        label: "Précision",
    }
}, BaseSchema]);

Places.attachSchema(PlaceSchema);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights/places.js
 **/